import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api';

// Async thunks
export const fetchTransactions = createAsyncThunk(
  'transactions/fetchTransactions',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.getUserTransactions(params);
      return response.data;
    } catch (error) {
      console.error('Error in fetchTransactions thunk:', error);
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch transactions');
    }
  }
);

// Transaction slice
const transactionSlice = createSlice({
  name: 'transactions',
  initialState: {
    transactions: [],
    loading: false,
    error: null,
    filters: {
      status: '',
      type: '',
      subscriptionId: null,
    },
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
    },
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      // Reset pagination when filters change
      state.pagination.page = 1;
    },
    setPage: (state, action) => {
      state.pagination.page = action.payload;
    },
    setLimit: (state, action) => {
      state.pagination.limit = action.payload;
      // Reset to page 1 when limit changes
      state.pagination.page = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransactions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.loading = false;
        // Ensure we have a valid transactions array
        state.transactions = Array.isArray(action.payload.transactions) 
          ? action.payload.transactions 
          : [];
        state.pagination.total = action.payload.total || 0;
        state.pagination.page = action.payload.page || 1;
        state.pagination.limit = action.payload.limit || 10;
      })
      .addCase(fetchTransactions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'An error occurred';
        state.transactions = [];
      });
  },
});

export const { setFilters, setPage, setLimit } = transactionSlice.actions;

export default transactionSlice.reducer;
